import { SET_CURRENT_LOCALE } from "../types"

const reducer = (state, action) => {
  switch(action.type) {
    case SET_CURRENT_LOCALE:
      return {
        ...state,
        currentLocale: action.payload,
        currentLanguage: action.payload.split('-')[0], // Extract language code from locale
      }
    default:
      return state
  }
}

export default reducer